import React from "react";
import { ShieldCheck, Clock, Home, Wallet, Wrench, RefreshCcw } from "lucide-react";

const items = [
    { icon: ShieldCheck, label: "1-Year Warranty Included" },
    { icon: RefreshCcw, label: "Extendable Warranty" },
    { icon: Clock, label: "1-Hour Free Installation" },
    { icon: Home, label: "Works With Existing Appliances" },
    { icon: Wallet, label: "Affordable · Starts at ₹17,999" },
    { icon: Wrench, label: "Professional Installation & Support" },
];

export default function TrustStrip() {
    return (
        <section className="border-y border-slate-200 bg-white" data-testid="trust-strip">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                    {items.map((it, i) => (
                        <div key={i} className="flex items-center gap-2.5 text-sm text-[#1B2E7A] font-medium" data-testid={`trust-item-${i}`}>
                            <div className="w-9 h-9 rounded-xl bg-[#E8F8FE] flex items-center justify-center shrink-0">
                                <it.icon className="w-4.5 h-4.5 text-[#1BB6F0]" strokeWidth={2.2} />
                            </div>
                            <span className="leading-tight">{it.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
